import React from "react";
import Nav from "./Nav";
import packageJson from "../../../package.json";
import {useTranslation} from 'react-i18next';

const ResponsiveMenu = ({show, onClose, showSearch, onSearch}) => {
    const { t } = useTranslation();
    const elements = document.querySelectorAll(
        ".popup-mobile-menu .has-droupdown > a"
    );
    const elementsTwo = document.querySelectorAll(
        ".popup-mobile-menu .with-megamenu > a"
    );
    const links = document.querySelectorAll(".has-droupdown .submenu li a");
    const menus = document.querySelectorAll(".popup-mobile-menu");
    links.forEach(function (element) {
        element.onclick = function () {
            menus.forEach((menu) => {
                menu.classList.remove("active");
            });
        };
    });
    elements.forEach(function (element) {
        element.onclick = function () {
            this.parentElement.querySelector(".submenu").classList.toggle("active");
            this.classList.toggle("open");
        };
    });

    elementsTwo.forEach(function (element) {
        element.onclick = function () {
            this.parentElement
                .querySelector(".rn-megamenu")
                .classList.toggle("active");
            this.classList.toggle("open");
        };
    });

    React.useEffect(() => {
        document?.addEventListener('click', (e) => {
            if(e?.target?.classList?.contains('active'))
                onClose()
        })
    }, [])

    return (
        <>
            <div className={`popup-mobile-menu ${show ? "active" : ""}`}>
                <div className="inner">
                    <div className="header-top">
                        <div
                            className="logo"
                            style={{display: "flex", alignItems: "center"}}
                        >
                            <a href={`https://www.happysolutions.hu/?utm_source=orderPage`} target="_blank" rel="noreferrer">
                                <img
                                    className="logo-light"
                                    src="https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/logo.png"
                                    alt={t('footer.brandAlt')}
                                />
                            </a>
                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                {<span
                                    style={{
                                        fontWeight: 100,
                                        fontSize: 12,
                                        position: "absolute",
                                        bottom: 25,
                                    }}
                                >
                  (v{packageJson.version})
                </span>}
                                <h4
                                    className="m-0"
                                    style={{fontSize: 25, whiteSpace: "nowrap", width: 246}}
                                >
                                    {t('common.appName')} <br/>
                                    <small>
                                        {t('common.appTagline')}
                                    </small>
                                </h4>
                            </div>
                        </div>
                        <div className="close-menu" style={{width: 100}}>
                            <button className="close-button" onClick={onClose}>
                                <i className="ri-close-line"></i>
                            </button>
                        </div>
                    </div>
                    <Nav/>

                </div>
            </div>

            <div className={`edu-search-popup ${showSearch ? "open" : ""}`}>
                <div className="close-button">
                    <button className="close-trigger" onClick={onSearch}>
                        <i className="ri-close-line"></i>
                    </button>
                </div>
                <div className="inner">
                    <form className="search-form" action="#">
                        <input
                            type="text"
                            className="eduvibe-search-popup-field"
                            placeholder={t('common.searchPlaceholder')}
                        />
                        <button className="submit-button">
                            <i className="icon-search-line"></i>
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
};

export default ResponsiveMenu;
